import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const genericRecordSave: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordSave">,
    GQL.IMutationGenericRecordSaveArgs
> = gql`
    mutation genericRecordSave($input: GenericRecordSaveInput!) {
        genericRecordSave(input: $input) {
            status
            summary {
                id
                action
                productId
            }
        }
    }
`;

export const genericRecordsDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsDelete">,
    GQL.IMutationGenericRecordsDeleteArgs
> = gql`
    mutation genericRecordsDelete($input: GenericRecordsIDInput!) {
        genericRecordsDelete(input: $input) {
            status
            summary {
                id
                action
                productId
            }
        }
    }
`;
export const genericRecordDocuments: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordDocuments">,
    GQL.IMutationGenericRecordDocumentsArgs
> = gql`
    mutation genericRecordDocuments($input: GenericRecordDocumentsInput!) {
        genericRecordDocuments(input: $input) {
            status
            summary {
                id
                action
                productId
            }
        }
    }
`;
export const genericRecordsCancel: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsCancel">,
    GQL.IMutationGenericRecordsCancelArgs
> = gql`
    mutation genericRecordsCancel($input: GenericRecordsIDInput!) {
        genericRecordsCancel(input: $input) {
            status
            summary {
                id
                action
                productId
            }
        }
    }
`;

export const genericRecordsConfirm: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsConfirm">,
    GQL.IMutationGenericRecordsConfirmArgs
> = gql`
    mutation genericRecordsConfirm($input: GenericRecordsIDInput!) {
        genericRecordsConfirm(input: $input)
    }
`;

export const genericRecordsJournal: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsJournal">,
    GQL.IMutationGenericRecordsJournalArgs
> = gql`
    mutation genericRecordsJournal($input: GenericRecordsIDInput!) {
        genericRecordsJournal(input: $input)
    }
`;

export const genericRecordsAvis: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsAvis">,
    GQL.IMutationGenericRecordsAvisArgs
> = gql`
    mutation genericRecordsAvis($input: GenericRecordsIDInput!, $avis: Boolean!) {
        genericRecordsAvis(input: $input, avis: $avis)
    }
`;

export const genericRecordsColor: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsColor">,
    GQL.IMutationGenericRecordsColorArgs
> = gql`
    mutation genericRecordsColor($input: GenericRecordsIDInput!, $color: DocumentColors) {
        genericRecordsColor(input: $input, color: $color)
    }
`;

export const genericRecordsReview: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsReview">,
    GQL.IMutationGenericRecordsReviewArgs
> = gql`
    mutation genericRecordsReview($input: GenericRecordsReviewInput!) {
        genericRecordsReview(input: $input)
    }
`;
export const genericRecordsAiReview: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsAiReview">,
    GQL.IMutationGenericRecordsAiReviewArgs
> = gql`
    mutation genericRecordsAiReview($input: GenericRecordsIDInput!) {
        genericRecordsAiReview(input: $input)
    }
`;
export const genericRecordsSetPriorities: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsSetPriorities">,
    GQL.IMutationGenericRecordsSetPrioritiesArgs
> = gql`
    mutation genericRecordsSetPriorities($input: GenericRecordsSetPrioritiesInput!) {
        genericRecordsSetPriorities(input: $input)
    }
`;
export const genericRecordsImport: TypedDocumentNode<
    Pick<GQL.IMutation, "genericRecordsImport">,
    GQL.IMutationGenericRecordsImportArgs
> = gql`
    mutation genericRecordsImport($input: GenericRecordsImportInput!) {
        genericRecordsImport(input: $input)
    }
`;
